import Text from './Text';
import React from 'react';
import { OrderingHooks } from 'polygon-ordering';
import OrderDetailsPurchasesChoice from './OrderDetailsPurchasesChoice';

const { useFormattedCurrency } = OrderingHooks;

type OrderDetailsLine = ReceiptItem | PurchaseWithTotals;

const OrderDetailsPurchases = ({ stagedPurchase }: { stagedPurchase: OrderDetailsLine }) => {
  const price = useFormattedCurrency({
    cents:
      (stagedPurchase as ReceiptItem)?.price ??
      (stagedPurchase as PurchaseWithTotals)?.baseMoneyPrice,
  });

  const allChoices = Object.values(
    (stagedPurchase as ReceiptItem)?.choicesets ??
      (stagedPurchase as PurchaseWithTotals)?.choicesWithQuantity ??
      {},
  ).flat();

  return (
    <>
      <div style={styles.items}>
        <Text
          themeKey="orderDetailsCart"
          style={styles.description}
          value={
            (stagedPurchase as ReceiptItem)?.name ??
            (stagedPurchase as PurchaseWithTotals)?.item.name
          }
        />

        <Text
          themeKey="orderDetailsCart"
          style={styles.qty}
          value={String(stagedPurchase.quantity)}
        />
        <Text
          themeKey="orderDetailsCart"
          style={styles.points}
          value={
            (stagedPurchase as ReceiptItem).points
              ? String((stagedPurchase as ReceiptItem).points)
              : ''
          }
        />
        <Text themeKey="orderDetailsCart" style={styles.price} value={price} />
      </div>
      {/* This was stolen from the similar price breakdown in StagedPurchase.tsx */}
      {!!allChoices.length &&
        allChoices.map(
          (
            choice: ReceiptItem | (ChoiceWithQuantity | NestedChoiceWithQuantity),
            index: number,
          ) => {
            return (
              <React.Fragment key={index}>
                <OrderDetailsPurchasesChoice stagedPurchaseChoice={choice} />
              </React.Fragment>
            );
          },
        )}
    </>
  );
};

export default OrderDetailsPurchases;

const styles = {
  description: {
    width: '50%',
    fontWeight: 'bold',
  },
  qty: {
    width: '10%',
    display: 'flex',
    justifyContent: 'center',
  },
  points: {
    width: '20%',
    display: 'flex',
    justifyContent: 'center',
  },
  price: {
    width: '20%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  items: {
    display: 'flex',
    margin: '5px 0 5px 0',
  },
};
